document.addEventListener('DOMContentLoaded', function () {

	const textarea = document.querySelector('textarea[name="chosa_gaiyou"]');
	if (!textarea) return;

	textarea.placeholder = `・倫理指針や個人情報保護法に準拠した、IRB（倫理審査）申請用の書類作成を支援してほしい
・査読に耐えうる、論理整合性の取れた精度の高いデータクリーニングを依頼したい
・出現率の低い希少な対象者や、特定の属性条件で十分なサンプル数を確保したい
・科研費などの公費払いに対応し、限られた予算内で柔軟に調査設計を相談したい`;

});
